import * as types from "./appointmentActions";

export const defaultTimeValue = "Select time...";

const initialState = {
  appointmentDate: "",
  appointmentTime: defaultTimeValue,
  appointmentTimeSlot: defaultTimeValue,
  timeStepIsActive: false,
  availableAppointmentDates: [],
  salesRepID: "", // lixil reponse sales id
  appointmentsNotAvailable: true, // lixil faraday reponse not available for this address
};

export default function(state = initialState, action) {

  switch(action.type) {

    case types.SET_APPOINTMENT_DATE:
      return {...state, appointmentDate: action.payload, appointmentTime: defaultTimeValue, appointmentTimeSlot: defaultTimeValue}
    case types.SET_APPOINTMENT_TIME:
      return {...state,
        appointmentTime: action.payload.time,
        appointmentTimeSlot: action.payload.timeSlot
      }
    case types.SET_APPOINTMENT_TIME_STEP_ACTIVE:
      return {...state, timeStepIsActive: action.payload}
    case types.SET_AVAILABLE_APPOINTMENTS:
    case types.SET_SALES_REP_ID:
    case types.SET_APPOINTMENTS_NOT_AVAILABLE:
      return {...state, ...action.payload}

  }

  return state;

}
